const startYear = 2020
const now = new Date().getFullYear() - startYear

const hobbies = [
    "building PCs", 
    "working on cars",
    "gaming",
    "climbing",
    "fishing",
    "finding good food places"
].join(", ")
export const bio =`I am an Innovative Software Developer with ${now}+ years 
of hands-on experience designing, debugging, and testing applications. 
My computer science career started in August 2014 when I learned Java as my first language in high school 
senior year and developed basic console applications. Since then, I've been expanding my skillset in
Python and C++ at Austin Community College for the next two years. Finally in April of 2017, I got accepted to 
UT Austin's computer science program, where I spent my time building my skillset in Git, Bash, Debugging, HTML, CSS, and JS for the next three years.
As of May 23rd 2020, (during the pandemic) I graduated with a Bachelor's of Science in Computer Science, (🤘 HOOK'EM! 🤘) landing my first Software Engineering 
job at Infosys. Since then, I have continuously upskilled myself by learning to utilize different tools such as React, Angular, SpringBoot, ExpressJS, TypeScript,
SQL and MongoDB on various projects. Anytime I'm not coding, I'm usually ${hobbies}, or just hanging out with people because an online life is no social life at all.`
export {}